export const formatWorkerId = (workerId: string): string => {
  // 5桁未満の場合は0埋め
  return workerId.padStart(5, '0')
}
export const validateWorkerId = (workerId: string): boolean => {
  return /^\d{5}$/.test(workerId)
}
